import {ConfigText} from 'components/common/ConfigText'
import {ErrorMessage} from 'components/common/ErrorMessage'
import {Button} from 'components/system/Button'
import {StandardInputField} from 'components/system/fields/StandardInputField'
import {FORM_ERROR} from 'final-form'
import {useApplyDiscountCodeMutation} from 'hooks/ventrata/useApplyDiscountCode'
import {ReactComponent as AppliedIcon} from 'icons/applied.svg'
import {ReactComponent as WalletIcon} from 'icons/wallet.svg'
import {OrderProvider} from 'providers/OrderProvider'
import {useCallback, useState} from 'react'
import {Form} from 'react-final-form'
import {getDiscountDetails} from 'utils/getDiscountDetails'

export const Discount = () => {
  const order = OrderProvider.useOrder()
  const setOrder = OrderProvider.useOrderSetter()
  const applyDiscountCodeMutation = useApplyDiscountCodeMutation()
  const applyDiscountCodeMutateAsync = applyDiscountCodeMutation.mutateAsync

  const discountDetails = getDiscountDetails(order)

  const [shown, setShown] = useState(discountDetails !== null)

  const showForm = useCallback(() => setShown(true), [])
  const hideForm = useCallback(() => setShown(false), [])

  const onSubmit = useCallback(
    async (values: Record<string, any>) => {
      try {
        const updatedOrder = await applyDiscountCodeMutateAsync({order, code: values.code})
        setOrder(updatedOrder)
      } catch (error: any) {
        return {[FORM_ERROR]: error.message}
      }
    },
    [applyDiscountCodeMutateAsync, order, setOrder]
  )

  if (discountDetails) {
    return (
      <div className="bg-white border-solid border-t border-x border-gray-4 p-4 flex flex-col gap-2">
        <div className="flex gap-2 items-center">
          <div className="px-4 py-3 rounded-lg bg-input-background border-solid border-input-border w-full">
            {discountDetails.code}
          </div>
          <AppliedIcon className="min-w-6" />
        </div>
        <div className="text-sm text-green-600">Promotion applied</div>
      </div>
    )
  }

  return (
    <div className="bg-white border-solid border-gray-4 border-x border-t p-4">
      {shown ? (
        <Form
          onSubmit={onSubmit}
          render={({handleSubmit, values, submitError}) => {
            return (
              <form onSubmit={handleSubmit} className="flex flex-col gap-2">
                <div className="flex gap-2 items-center">
                  <StandardInputField name="code" type="text" spellCheck={false} />
                  {values.code ? (
                    <Button.Secondary.Black type="submit" className="w-[96px]">
                      Apply
                    </Button.Secondary.Black>
                  ) : (
                    <Button.Secondary.Black onClick={hideForm} className="w-[96px]">
                      Cancel
                    </Button.Secondary.Black>
                  )}
                </div>
                {submitError && <ErrorMessage error={submitError} />}
              </form>
            )
          }}
        />
      ) : (
        <Button className="flex gap-2 text-dark-blue items-center" onClick={showForm}>
          <WalletIcon />
          <div>
            <ConfigText configKey="discountPrompt" defaultText="Got a promo/gift card code?" />
          </div>
        </Button>
      )}
    </div>
  )
}
